import { render, staticRenderFns } from "./GonggaoDetail.vue?vue&type=template&id=7ec83bd8&scoped=true"
import script from "./GonggaoDetail.vue?vue&type=script&lang=js"
export * from "./GonggaoDetail.vue?vue&type=script&lang=js"
import style0 from "./GonggaoDetail.vue?vue&type=style&index=0&id=7ec83bd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec83bd8",
  null
  
)

export default component.exports